"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TestId = void 0;
let TestId = exports.TestId = /*#__PURE__*/function (TestId) {
  // Blocked payment provider component
  TestId["BlockedPaymentProvider"] = "blocked-payment-provider";
  // Blocked payment providers component as map of blocked providers
  TestId["BlockedPaymentProviders"] = "blocked-payment-providers";
  // Card detail consent form
  TestId["CardDetailsConsent"] = "card-details-consent";
  // Footer card detail text
  TestId["CardDetailsExpiration"] = "card-details-expiration";
  // Footer card number text
  TestId["CardDetailsNumber"] = "card-details-number";
  // Donation toggle card
  TestId["DonationCard"] = "donation-card";
  // Donation label inside donation box
  TestId["DonationLabel"] = "donation-label";
  // Donation description text
  TestId["DonationLongDescription"] = "donation-long-description";
  // Text for donation message
  TestId["DonationMessage"] = "donation-message";
  // Donation section wrapper
  TestId["DonationSection"] = "donation-section";
  // Error icon for blocked payment provider
  TestId["ErrorCircleIcon"] = "ErrorCircleIcon";
  // Donation box component
  TestId["PaymentDonation"] = "payment-donation";
  // Payment label inside payment provider box
  TestId["PaymentLabel"] = "payment-label";
  // Payment provider box component
  TestId["PaymentProviderBox"] = "payment-provider-box";
  // Payment footer wrapper
  TestId["PaymentProviderFooter"] = "payment-provider-footer";
  // Payment provider group component
  TestId["PaymentProviderGroup"] = "payment-provider-group";
  // Payment header wrapper
  TestId["PaymentProviderHeader"] = "payment-provider-header";
  // Lazy image
  TestId["PaymentProviderImage"] = "payment-provider-image";
  // Payment providers radion selection
  TestId["PaymentProvidersRadioSelection"] = "payment-providers-radio-selection";
  // Provider method icon wrapper
  TestId["ProviderMethodIcon"] = "provider-method-icon";
  // Skeleton for payment providers
  TestId["SkeletonPaymentProviders"] = "skeleton-payment-providers";
  // Payment section
  TestId["PaymentSection"] = "payment-section";
  return TestId;
}({});